const state = () => ({
  allData: [],
  dataDetail: [],
  totalData: 0,
  loading: false,
  cacheData: {},
  errors: [],
  flashErrorMessage: '',
  flashError: false,
  item: null,
  insertProgress: 0,
  downloadFailedURL: '',
  countDone: 0,
  countSame: 0,
  intervalExport: null,
  exportId: null,
  countDataExport: 0,
  totalPage: 0,
  requestData: null,
  percentage: 0,
  insertStatus: false,
  approvedStatus: 'failed',
  countSameInsert: 0,
  countDoneInsert: 0,
  insertId: null,
  countDataInsert: 0,
  intervalInsert : null,
  showProgressBar: false,
  progressTitle: "Processing Approval",
  progressColor: "grey",
  isFailedResponse: false,
  onDownloadResult: false,
});

export default state;
